import { useState } from 'react';
import Layout from '../components/Layout.jsx';
import { api, getUser } from '../api.js';

export default function Cuenta() {
  const me = getUser();
  const [actual, setActual] = useState('');
  const [nuevo, setNuevo] = useState('');
  const [confirmar, setConfirmar] = useState('');
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setMsg('');
    if (nuevo !== confirmar) { setMsg('Los PINs nuevos no coinciden.'); return; }
    if (nuevo.length < 4) { setMsg('PIN nuevo debe tener al menos 4 dígitos.'); return; }
    setLoading(true);
    try {
      await api.cambiarPin(actual, nuevo);
      setMsg('✓ PIN cambiado.');
      setActual(''); setNuevo(''); setConfirmar('');
    } catch (err) {
      setMsg(err.message === 'pin_actual_incorrecto' ? 'PIN actual incorrecto.' : 'Error: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="mb-8">
        <p className="eyebrow mb-2">Tu cuenta</p>
        <h1 className="text-4xl md:text-5xl font-bold tracking-tight">Cuenta y seguridad</h1>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl">
        <div className="card">
          <p className="eyebrow mb-3">Tus datos</p>
          <div className="space-y-3 font-mono text-sm">
            <Row label="Nombre" valor={me?.nombre} />
            <Row label="Rol" valor={me?.rol} />
            <Row label="Empresa" valor={`Tenant ${me?.tenant_id}`} />
          </div>
        </div>

        <form onSubmit={submit} className="card space-y-4">
          <p className="eyebrow">Cambiar PIN</p>
          <div>
            <label className="label">PIN actual</label>
            <input className="input text-center text-xl tracking-widest" type="password" inputMode="numeric" minLength={4} maxLength={8} value={actual} onChange={(e) => setActual(e.target.value)} required />
          </div>
          <div>
            <label className="label">PIN nuevo</label>
            <input className="input text-center text-xl tracking-widest" type="password" inputMode="numeric" minLength={4} maxLength={8} value={nuevo} onChange={(e) => setNuevo(e.target.value)} required />
          </div>
          <div>
            <label className="label">Confirmar PIN nuevo</label>
            <input className="input text-center text-xl tracking-widest" type="password" inputMode="numeric" minLength={4} maxLength={8} value={confirmar} onChange={(e) => setConfirmar(e.target.value)} required />
          </div>
          {msg && (
            <div className={`rounded-2xl px-3 py-2 text-sm font-mono ${msg.startsWith('✓') ? 'bg-lime/30 text-ink' : 'bg-red-50 text-red-800 border border-red-200'}`}>{msg}</div>
          )}
          <button className="btn-primary w-full" disabled={loading}>{loading ? 'Guardando…' : 'Cambiar PIN'}</button>
        </form>
      </div>
    </Layout>
  );
}

function Row({ label, valor }) {
  return (
    <div className="flex items-center justify-between border-b border-line/60 py-2 last:border-0">
      <span className="text-muted">{label}</span>
      <span className="font-semibold text-ink">{valor}</span>
    </div>
  );
}
